module.exports = __webpack_public_path__ + "img/tab-active-bg.42684a9c.png";